import { useEffect, useRef, useState } from "react";
import useFlow from "../hooks/useFlow";
import moment from "moment-timezone";
import { Image } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function EventsOverlay() {
  const { loadSchedules, timezoneRef } = useFlow();
  const [schedules, setSchedules] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const date = moment.tz(timezoneRef.current).format("YYYY-MM-DD");
    loadSchedules("events", date).then((data) => {
      setSchedules(data);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Idle handling
  const timeoutIdRef = useRef(null);
  const timeoutSeconds = 10;

  const resetTimeout = () => {
    setShowOverlay(false);
    if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      setShowOverlay(true);
    }, timeoutSeconds * 1000);
  };
  useEffect(() => {
    resetTimeout();

    window.addEventListener("keydown", resetTimeout);
    window.addEventListener("mousemove", resetTimeout);

    return () => {
      if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
      window.removeEventListener("keydown", resetTimeout);
      window.removeEventListener("mousemove", resetTimeout);
    };
  }, []);

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 360 },
      items: 1,
      partialVisibilityGutter: 50,
    },
  };

  return (
    <div
      className={`homeSlider ${showOverlay ? "homeSliderShow" : null}`}
      onClick={() => {
        resetTimeout();
        setShowOverlay(false);
      }}
    >
      {schedules.length && (
        <div className="homeSliderBlock pt-5 mt-5">
          <p className="text-center fs-2 mb-5">
            Move the mouse or touch the screen to use the check-in
          </p>
          <Carousel
            className="customCarousel"
            responsive={responsive}
            autoPlay
            infinite
            centerMode
            autoPlaySpeed={5000}
            arrows={false}
            pauseOnHover={false}
          >
            {schedules.map((schedule, index) => (
              <div
                key={index}
                className="homeSliderItem"
                onClick={resetTimeout}
                onMouseMove={resetTimeout}
                onTouchStart={resetTimeout}
                onKeyDown={resetTimeout}
              >
                <Image
                  src={
                    schedule.classImage ||
                    "https://flowyogatx.com/assets/images/press/flow_yoga_anderson_room2.jpg"
                  }
                  className="rounded-4"
                />
                <p className="fs-4">{schedule.fullname}</p>
                <p className="fs-5 text-center">
                  {schedule.startDateFormatted}
                  <br />
                  from {schedule.startTimeFormatted} -{" "}
                  {schedule.endTimeFormatted}
                </p>
              </div>
            ))}
          </Carousel>
          <p className="text-center fs-3">
            Check the events page for more information
          </p>
        </div>
      )}
    </div>
  );
}
